export default __webpack_public_path__ + "static/realtimechat-01decfe482919b2cfc517df6b8bb1031.mp4";